import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/github.svg'


const _hoisted_1 = { class: "SiteNavbar" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<nav class=\"bg-white border-gray-200 dark:bg-gray-900\"><div class=\"max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4\"><span class=\"self-center text-2xl font-semibold whitespace-nowrap dark:text-white\">Sortify</span><a href=\"https://github.com/iAliF/Sortify/\" class=\"block py-2 pr-3\" target=\"_blank\"><img src=\"" + _imports_0 + "\" alt=\"GitHub\" class=\"h-8\"></a></div></nav>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}